import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingComponent } from './landing.component';
import { LandingRoutes } from './landing.routing';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    LandingRoutes,
    SharedModule
  ],
  declarations: [
    LandingComponent
  ]
})
export class LandingModule { }
